import React from 'react';
import styles from './UIGameVoteParticipants.module.scss';
import { Avatar } from '../../../common/Avatar/index.ts';
import IconPlayerStatusAccept from '@static/images/player_status_accept.svg';
import IconPlayerStatusReject from '@static/images/player_status_reject.svg';
import IconPlayerStatusPending from '@static/images/player_status_pending.svg';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
const getStatusIcon = ({ isAccepted, isDeclined, isPending })=>{
    if (isAccepted) return IconPlayerStatusAccept;
    if (isDeclined) return IconPlayerStatusReject;
    if (isPending) return IconPlayerStatusPending;
    return undefined;
};
export const UIGameVoteParticipants = ({ acceptedVotes, declinedVotes, participatingPlayers })=>{
    const { getPlayerValidator } = usePlayerValidators();
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.playersContainer
    }, participatingPlayers.map((playerColor)=>{
        const player = getPlayerValidator(playerColor);
        if (player == null) return null;
        const isAccepted = acceptedVotes.includes(playerColor);
        const isDeclined = declinedVotes.includes(playerColor);
        const isPending = !isAccepted && !isDeclined;
        return /*#__PURE__*/ React.createElement("div", {
            key: playerColor,
            className: styles.playerWrapper
        }, /*#__PURE__*/ React.createElement(Avatar, {
            color: player.color,
            className: styles.avatar,
            image: player.displayIcon,
            profilePictureUrl: player.profilePictureUrl
        }), /*#__PURE__*/ React.createElement("img", {
            src: getStatusIcon({
                isAccepted: isAccepted,
                isDeclined: isDeclined,
                isPending: isPending
            }),
            className: styles.statusIcon
        }));
    }));
};
